import NavigationBar from "../../../navigation_components/NavigationBar";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/SubscriptionPlans/SubscriptionPlans.css";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import { AppContext } from "../../../AppProvider";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";

const SubscriptionPlans = () =>{
    const navigate = useNavigate();
    const { user,logout } = useContext(AppContext);
    const[tenantAdminProfiles,setTenantAdminProfiles] = useState([]);
    const[selectedTenantAdminProfile,setSelectedTenantAdminProfile] = useState(null);
    const[selectedTenantAdminServerProfileCustomers,setSelectedTenantAdminServerProfileCustomers] = useState([]);
    const[fetchingSelectedTenantAdminServerProfilesCustomers,setFetchingSelectedTenantAdminServerProfilesCustomers] = useState(false);
    const[selectedNewSubscriptionPlanCustomer,setSelectedNewSubscriptionPlanCustomer] = useState(null);
    const[selectedEditSubscriptionPlanCustomer,setSelectedEditSubscriptionPlanCustomer] = useState(null);

    const[showAddSubscriptionPlan,setShowAddSubscriptionPlan] = useState(false);
    const[showAddingSubscriptionPlan,setShowAddingSubscriptionPlan] = useState(false);
    const[showAddSubscriptionPlanCustomersBrowser,setShowAddSubscriptionPlanCustomersBrowser] = useState(false);
    const[newSubscriptionPlanActiveTab,setNewSubscriptionPlanActiveTab] = useState('details');
    const[newSubscriptionPlanName,setNewSubscriptionPlanName] = useState('');
    const[newSubscriptionPlanPrice,setNewSubscriptionPlanPrice] = useState('');
    const[newSubscriptionPlanTax,setNewSubscriptionPlanTax] = useState('');
    const[newSubscriptionPlanDuration,setNewSubscriptionPlanDuration] = useState('');
    const[newSubscriptionPlanDeactivationWindowDuration,setNewSubscriptionPlanDeactivationWindowDuration] = useState('');
    const[newSubscriptionPlanDeactivationWindowDurationUnits,setNewSubscriptionPlanDeactivationWindowDurationUnits] = useState('');
    const[newSubscriptionPlanFeatures,setNewSubscriptionPlanFeatures] = useState([]);
    const[newSubscriptionPlanVisible,setNewSubscriptionPlanVisible] = useState(false);
    const[newSubscriptionPlanAllCustomers,setNewSubscriptionPlanAllCustomers] = useState(false);
    const[newSubscriptionPlanCustomers,setNewSubscriptionPlanCustomers] = useState('ALL');
    const[newSubscriptionPlanCustomersLocalIds,setNewSubscriptionPlanCustomersLocalIds] = useState([]);

    const[showEditSubscriptionPlan,setShowEditSubscriptionPlan] = useState(false);
    const[loadingEditSubscriptionPlanCustomers,setLoadingEditSubscriptionPlanCustomers] = useState(false);
    const[showUpdatingSubscriptionPlan,setShowUpdatingSubscriptionPlan] = useState(false);
    const[showEditSubscriptionPlanCustomersBrowser,setShowEditSubscriptionPlanCustomersBrowser] = useState(false);
    const[editSubscriptionPlanActiveTab,setEditSubscriptionPlanActiveTab] = useState('details');
    const[editSubscriptionPlan,setEditSubscriptionPlan] = useState(null);
    const[editSubscriptionPlanName,setEditSubscriptionPlanName] = useState('');
    const[editSubscriptionPlanPrice,setEditSubscriptionPlanPrice] = useState('');
    const[editSubscriptionPlanTax,setEditSubscriptionPlanTax] = useState('');
    const[editSubscriptionPlanDuration,setEditSubscriptionPlanDuration] = useState('');
    const[editSubscriptionPlanDeactivationWindowDuration,setEditSubscriptionPlanDeactivationWindowDuration] = useState('');
    const[editSubscriptionPlanDeactivationWindowDurationUnits,setEditSubscriptionPlanDeactivationWindowDurationUnits] = useState('');
    const[editSubscriptionPlanFeatures,setEditSubscriptionPlanFeatures] = useState([]);
    const[editSubscriptionPlanVisible,setEditSubscriptionPlanVisible] = useState(false);
    const[editSubscriptionPlanAllCustomers,setEditSubscriptionPlanAllCustomers] = useState(false);
    const[editSubscriptionPlanCustomers,setEditSubscriptionPlanCustomers] = useState('ALL');
    const[editSubscriptionPlanCustomersLocalIds,setEditSubscriptionPlanCustomersLocalIds] = useState([]);

    const[showDeleteSubscriptionPlan,setShowDeleteSubscriptionPlan] = useState(false);
    const[showDeletingSubscriptionPlan,setShowDeletingSubscriptionPlan] = useState(false);
    const[deleteSubscriptionPlan,setDeleteSubscriptionPlan] = useState(null);

    const[subscriptionPlans,setSubscriptionPlans] = useState(null);
    const fetchSubscriptionPlans = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/subscription/plans`
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setSubscriptionPlans(await response.json());
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when fetching all subscription plans:',error);
        }
    };
    const createNewSubscriptionPlan = async() =>{
        setShowAddSubscriptionPlan(false);
        setShowAddingSubscriptionPlan(true);
        try{
            const newSubscriptionPlan = {
                name: newSubscriptionPlanName,
                price: Number(newSubscriptionPlanPrice.replace(/[^\d.]/g,'')),
                taxRate: Number(newSubscriptionPlanTax.replace(/[^\d.]/g,'')) / 100,
                duration: newSubscriptionPlanDuration,
                deactivationWindow: computeDeactivationWindow(
                    newSubscriptionPlanDeactivationWindowDuration,
                    newSubscriptionPlanDeactivationWindowDurationUnits
                ),
                features: newSubscriptionPlanFeatures.map(feature => feature.name),
                visible: newSubscriptionPlanVisible,
                customersGlobal: newSubscriptionPlanCustomers === 'ALL',
                customerIds: newSubscriptionPlanCustomers !== 'ALL' && Array.isArray(newSubscriptionPlanCustomers)?
                    newSubscriptionPlanCustomers.map(({ customer }) => (customer?.local?.id)).filter(Boolean):[]
            };
            const url = `${billingMicroserviceUrl}/tenants/subscription/plans`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                },
                body:JSON.stringify(newSubscriptionPlan)
            });
            if(response.ok){
                await fetchSubscriptionPlans();
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when creating a new subscription plan:',error);
        }
        setShowAddingSubscriptionPlan(false);
    };
    const updateSubscriptionPlan = async() =>{
        setShowEditSubscriptionPlan(false);
        setShowUpdatingSubscriptionPlan(true);
        try{
            const selectedUpdateSubscriptionPlan = {
                name: editSubscriptionPlanName,
                price: Number(editSubscriptionPlanPrice.replace(/[^\d.]/g,'')),
                taxRate: Number(editSubscriptionPlanTax.replace(/[^\d.]/g,'')) / 100,
                duration: editSubscriptionPlanDuration,
                deactivationWindow: computeDeactivationWindow(
                    editSubscriptionPlanDeactivationWindowDuration,
                    editSubscriptionPlanDeactivationWindowDurationUnits
                ),
                features: editSubscriptionPlanFeatures.map(feature => feature.name),
                visible: editSubscriptionPlanVisible,
                customersGlobal: editSubscriptionPlanCustomers === 'ALL',
                customerIds: editSubscriptionPlanCustomers !== 'ALL' && Array.isArray(editSubscriptionPlanCustomers)?
                    editSubscriptionPlanCustomers.map(({customer}) => (customer?.local?.id)).filter(Boolean):[]
            };
            const url = `${billingMicroserviceUrl}/tenants/subscription/plans/${editSubscriptionPlan?.id}`;
            const response = await fetch(url,{
                method:'PUT',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body:JSON.stringify(selectedUpdateSubscriptionPlan)
            });
            if(response.ok){
                await fetchSubscriptionPlans();
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when updating a subscription plan with id: ${editSubscriptionPlan.id? editSubscriptionPlan?.id:'NULL'} -> `,error);
        }
        setShowUpdatingSubscriptionPlan(false);
    };
    const DeleteSubscriptionPlan = async() =>{
        setShowDeleteSubscriptionPlan(false);
        setShowDeletingSubscriptionPlan(true);
        try{
            const url = `${billingMicroserviceUrl}/tenants/subscription/plans/${deleteSubscriptionPlan.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                await fetchSubscriptionPlans();
                setDeleteSubscriptionPlan(null);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when deleting a subscription plan with id: ${deleteSubscriptionPlan?.id? deleteSubscriptionPlan.id:'NULL'} -> `,error);
        }
        setShowDeletingSubscriptionPlan(false);
    }
    const computeDeactivationWindow = (duration,units) =>{
        switch(units){
            case 'HOURS': return duration * 3600;
            case 'DAYS': return duration * 86400;
            case 'WEEKS': return duration * 604800;
            case 'MONTHS': return duration * 2592000;
        }
    };
    const reverseComputeDeactivationWindow = (milliseconds) =>{
        const units = [
            { unit: 'MONTHS', value: 2592000000 },
            { unit: 'WEEKS', value: 604800000 },
            { unit: 'DAYS', value: 86400000 },
            { unit: 'HOURS', value: 3600000 }
        ];
        for(const{ unit, value} of units){
            if(value !== 0 && milliseconds % value === 0){
                return {duration: String(milliseconds / value), unit};
            }
        }
        return null;
    };
    const fetchServerProfiles = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setTenantAdminProfiles(responseData);
            }
        }
        catch(error){
            console.error(error);
        }
    }
    const fetchCustomers = async(tenantAdminProfile) =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantAdminProfile?.id}/customers`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) return await response.json();
            else if(Number(response.status) === 401) logout();
            else throw new Error(`status code: ${response.status}`)
        }
        catch(error){
            console.error('An error occurred when loading customers from the server:',error);
        }
    };
    useEffect(()=>{
        if(showAddSubscriptionPlan){
            setNewSubscriptionPlanActiveTab('details');
            setNewSubscriptionPlanName('');
            setNewSubscriptionPlanPrice('');
            setNewSubscriptionPlanTax('');
            setNewSubscriptionPlanDuration('');
            setNewSubscriptionPlanDeactivationWindowDuration('');
            setNewSubscriptionPlanDeactivationWindowDurationUnits('');
            setNewSubscriptionPlanFeatures([]);
            setShowAddSubscriptionPlanCustomersBrowser(false);
            setSelectedTenantAdminProfile(null);
            setSelectedNewSubscriptionPlanCustomer(null);
            setNewSubscriptionPlanCustomers('ALL');
            setNewSubscriptionPlanVisible(true);
        }
    },[showAddSubscriptionPlan]);
    useEffect(()=>{
        if(!showAddSubscriptionPlanCustomersBrowser){
            setTenantAdminProfiles([]);
            setSelectedTenantAdminProfile(null);
            setSelectedTenantAdminServerProfileCustomers([]);
            fetchServerProfiles();
        }
    },[showAddSubscriptionPlanCustomersBrowser]);
    useEffect(() =>{
        if(!selectedTenantAdminProfile) return;
        const fetchSelectedTenantAdminCustomers = async() =>{
            const customers = await fetchCustomers(selectedTenantAdminProfile);
            if(Array.isArray(customers)) setSelectedTenantAdminServerProfileCustomers(customers);
        }
        if(fetchingSelectedTenantAdminServerProfilesCustomers){
            fetchSelectedTenantAdminCustomers().finally(() => setFetchingSelectedTenantAdminServerProfilesCustomers(false));
        }
    },[fetchingSelectedTenantAdminServerProfilesCustomers,selectedTenantAdminProfile]);
    useEffect(() =>{
        if(Array.isArray(newSubscriptionPlanCustomers)) setNewSubscriptionPlanCustomersLocalIds(newSubscriptionPlanCustomers?.map((customer) => customer?.customer?.local?.id) ?? []);
        else setNewSubscriptionPlanCustomersLocalIds([]);
    },[newSubscriptionPlanCustomers]);
    useEffect(() =>{
        if(Array.isArray(editSubscriptionPlanCustomers)) setEditSubscriptionPlanCustomersLocalIds(editSubscriptionPlanCustomers?.map((customer) => customer?.customer?.local?.id) ?? []);
        else setEditSubscriptionPlanCustomersLocalIds([]);
    },[editSubscriptionPlanCustomers]);

    useEffect(() =>{
        if(showEditSubscriptionPlan){
            setEditSubscriptionPlanActiveTab('details');
            setEditSubscriptionPlanName('');
            setEditSubscriptionPlanPrice('');
            setEditSubscriptionPlanTax('');
            setEditSubscriptionPlanDuration('');
            setEditSubscriptionPlanDeactivationWindowDuration('');
            setEditSubscriptionPlanDeactivationWindowDurationUnits('');
            setEditSubscriptionPlanFeatures([]);
            setEditSubscriptionPlanVisible(false);
            setEditSubscriptionPlanAllCustomers(false);
            setEditSubscriptionPlanCustomers('ALL');
            setEditSubscriptionPlanCustomersLocalIds([]);
        }
    },[showEditSubscriptionPlan]);
    useEffect(() =>{
        if(!editSubscriptionPlan) return;
        setEditSubscriptionPlanName(editSubscriptionPlan?.name);
        setEditSubscriptionPlanPrice(!editSubscriptionPlan.price || editSubscriptionPlan.price === ''? '':'KES ' + Number(editSubscriptionPlan?.price).toLocaleString('en-US',{
            minimumFractionDigits:2,
            maximumFractionDigits:2
        }))
        setEditSubscriptionPlanTax(!editSubscriptionPlan.taxRate || editSubscriptionPlan.taxRate === ''? '':Number(editSubscriptionPlan.taxRate * 100).toLocaleString('en-US',{
            minimumFractionDigits:2,
            maximumFractionDigits:2
        }) + '%');
        setEditSubscriptionPlanDuration(editSubscriptionPlan?.duration);
        const deactivationWindow = reverseComputeDeactivationWindow(editSubscriptionPlan?.deactivationWindow);
        if(deactivationWindow !== null && deactivationWindow.duration && deactivationWindow.unit){
            setEditSubscriptionPlanDeactivationWindowDurationUnits(deactivationWindow.unit);
            setEditSubscriptionPlanDeactivationWindowDuration(deactivationWindow.duration);
        }
        if(editSubscriptionPlan.features){
            const uniqueIds = new Set();
            setEditSubscriptionPlanFeatures(
                editSubscriptionPlan.features.map(feature =>{
                    let id;
                    do{
                        id = Math.random().toString(36).slice(2,11);
                    } while(uniqueIds.has(id))
                    return { id, name: feature }
                })
            );
        }
        setEditSubscriptionPlanVisible(editSubscriptionPlan?.visible || false);
        if(editSubscriptionPlan?.customersGlobal) setEditSubscriptionPlanCustomers('ALL');
        setEditSubscriptionPlanCustomersLocalIds(editSubscriptionPlan?.customerIds);
        setLoadingEditSubscriptionPlanCustomers(true);
    },[editSubscriptionPlan]);
    useEffect(() =>{
        const loadEditSubscriptionPlanCustomers = async () =>{
            const subscriptionPlanLoadedCustomers = await Promise.all(
                tenantAdminProfiles.map(async(tenantAdminProfile) => {
                    const customers = await fetchCustomers(tenantAdminProfile);
                    return customers?.filter(customer => editSubscriptionPlanCustomersLocalIds.includes(customer?.local?.id)).map(filteredCustomer => ({
                        tenantAdminProfile:tenantAdminProfile,
                        customer:filteredCustomer
                    }));
                })
            );
            setEditSubscriptionPlanCustomers(subscriptionPlanLoadedCustomers.flat());
            setLoadingEditSubscriptionPlanCustomers(false);
        }
        if(!loadingEditSubscriptionPlanCustomers) return;
        else if(!Array.isArray(editSubscriptionPlanCustomersLocalIds) || editSubscriptionPlanCustomersLocalIds.length <= 0){
            setLoadingEditSubscriptionPlanCustomers(false);
            return;
        }
        if(!tenantAdminProfiles) fetchServerProfiles();
        else loadEditSubscriptionPlanCustomers();
    },[loadingEditSubscriptionPlanCustomers,tenantAdminProfiles,editSubscriptionPlanCustomersLocalIds]);
    useEffect(() =>{
        if(!showDeleteSubscriptionPlan) return;
        const handleKeyDown = (event) =>{
            if(event.key === 'Escape' && showDeleteSubscriptionPlan){
                setDeleteSubscriptionPlan(null);
                setShowDeleteSubscriptionPlan(false);
                document.activeElement?.blur();
            };
        }
        document.addEventListener('keydown',handleKeyDown);
        return () =>{
            document.removeEventListener('keydown',handleKeyDown);
        }
    },[showDeleteSubscriptionPlan]);
    useEffect(() =>{
        document.title = 'Blink Electrics | Subscription plans';
        fetchSubscriptionPlans();
    },[]);
    return(
        <div className="tenant-administrator-subscription-plans-page">
            <div style={{height:'100%'}}>
                <NavigationBar/>
                <div className="tenant-administrator-subscription-plans-page-layout">
                    <div>
                        <TenantAdministratorSideBar/>
                    </div>
                    <div className="tenant-administrator-subscription-plans-parent-container">
                        <div className="tenant-administrator-subscription-plans-container">
                            <div className="tenant-administrator-subscription-plans-header-container">
                                <h2>Subscription plans</h2>
                                <div className="tenant-administrator-subscription-plans-header-controls">
                                    <button
                                        title="Add a subscription plan"
                                        onClick={() => setShowAddSubscriptionPlan(true)}>
                                        <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`}/>
                                    </button>
                                </div>
                            </div>
                            <div className="tenant-administrator-subscription-plans-body-container">
                                {subscriptionPlans === null?
                                    (
                                        <div className="tenant-administrator-subscription-plans-loading-container">
                                            <div></div>
                                            <p>Loading subscription plans. Please wait...</p>
                                        </div>
                                    ):
                                    (
                                        <div className="tenant-administrator-subscription-plans-grid-container">
                                            {subscriptionPlans.map(subscriptionPlan =>(
                                                <div key={subscriptionPlan.id} className="tenant-administrator-subscription-plans-subscription-card">
                                                    <div className="title-container">
                                                        <p>{subscriptionPlan.name}</p>
                                                        <div>
                                                            <button
                                                                className="edit-subscription-button"
                                                                title="Edit plan">
                                                                <img src={`${process.env.PUBLIC_URL}/images/edit-icon.png`}
                                                                    onClick={() =>{
                                                                        setEditSubscriptionPlan(subscriptionPlan);
                                                                        setShowEditSubscriptionPlan(true);
                                                                    }}
                                                                />
                                                            </button>
                                                            <button
                                                                className="delete-subscription-button"
                                                                title="Delete plan"
                                                                onClick={() =>{
                                                                    setDeleteSubscriptionPlan(subscriptionPlan);
                                                                    setShowDeleteSubscriptionPlan(true);
                                                                }}>
                                                                <img src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="price-container">
                                                        <span className="currency-span">KES</span>
                                                        <strong>
                                                            {Number(subscriptionPlan.price).toLocaleString('en-US',{
                                                                minimumFractionDigits:0,
                                                                maximumFractionDigits:0
                                                            })}
                                                        </strong>
                                                        <span>+ {Number(subscriptionPlan.taxRate * 100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:4})}% VAT</span>
                                                    </div>
                                                    <div className="billing-cycle-container">
                                                        Billing Cycle: <strong>{subscriptionPlan.duration? subscriptionPlan.duration.charAt(0).toUpperCase() + subscriptionPlan.duration.slice(1).toLowerCase().replace('_',' '):'None'}</strong>
                                                    </div>
                                                    <div className="features-container">
                                                        {subscriptionPlan.features.map((feature,index) =>(
                                                            <p key={index} className="feature"><span>✔</span>{feature}</p>
                                                        ))}
                                                    </div>
                                                    <div className="subscribe-button-container">
                                                        <button
                                                            title="Navigate to devices to suscribe from the plan"
                                                            onClick={() => navigate('/tenants/devices/')}>Subscribe
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tenant-administrator-add-subscription-plan-container"
                style={{display:`${showAddSubscriptionPlan? 'flex':'none'}`}}>
                <div className="tenant-administrator-add-subscription-plan-main-container">
                    <div className="tenant-administrator-add-subscription-plan-header-container">
                        <h1>Add subscription plan</h1>
                        <p onClick={() => setShowAddSubscriptionPlan(false)}>&#10006;</p>
                    </div>
                    <div className="tenant-administrator-add-subscription-plan-body-container">
                        <div className="tenant-administrator-add-subscription-plan-navigation-bar">
                            <button className={`${newSubscriptionPlanActiveTab === 'details'? 'active':''}`}
                                onClick={() => setNewSubscriptionPlanActiveTab('details')}>Details</button>
                            <button className={`${newSubscriptionPlanActiveTab === 'visibility'? 'active':''}`}
                                onClick={() => setNewSubscriptionPlanActiveTab('visibility')}>Visibility</button>
                        </div>
                        <div className={`tenant-administrator-add-subscription-plan-details-container ${newSubscriptionPlanActiveTab === 'details'? 'active':'hidden'}`}>
                            <div className="components-container">
                                <p>Name<span>*</span></p>
                                <input
                                    type="text"
                                    placeholder="Enter the subscription plan name"
                                    value={newSubscriptionPlanName}
                                    onChange={(e) =>{
                                        setNewSubscriptionPlanName(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="components-container" title="Price of the suscription in KES">
                                <p>Price<span>*</span></p>
                                <input
                                    type="text"
                                    placeholder="Enter the price in KES"
                                    value={newSubscriptionPlanPrice}
                                    onChange={(e) =>{
                                        const value = e.target.value.replace(/,/g,'');
                                        if(/^\d*\.?\d{0,2}$/.test(value)) setNewSubscriptionPlanPrice(value)
                                    }}
                                    onFocus={(e) =>{
                                        setNewSubscriptionPlanPrice(newSubscriptionPlanPrice.replace(/[^\d.]/g,''));
                                    }}
                                    onBlur={(e) =>{
                                        if(newSubscriptionPlanPrice !== ''){
                                            setNewSubscriptionPlanPrice('KES ' + Number(newSubscriptionPlanPrice).toLocaleString('en-US',{
                                                minimumFractionDigits:2,
                                                maximumFractionDigits:2
                                            }))
                                        }
                                    }}
                                />
                            </div>
                            <div className="components-container">
                                <p>Tax<span>*</span></p>
                                <input
                                    placeholder="Enter tax in %"
                                    value={newSubscriptionPlanTax}
                                    onChange={(e) =>{
                                        const value = e.target.value.replace(/,/g,'');
                                        if(/^\d*\.?\d{0,2}$/.test(value)) setNewSubscriptionPlanTax(value)
                                    }}
                                    onFocus={(e) =>{
                                        setNewSubscriptionPlanTax(newSubscriptionPlanTax.replace(/[^\d.]/g,''));
                                    }}
                                    onBlur={(e) =>{
                                        if(newSubscriptionPlanTax !== ''){
                                            setNewSubscriptionPlanTax(Number(newSubscriptionPlanTax).toLocaleString('en-US',{
                                                minimumFractionDigits:2,
                                                maximumFractionDigits:2
                                            }) + '%');
                                        }
                                    }}
                                />
                            </div>
                            <div className="components-container">
                                <p>Billing cycle<span>*</span></p>
                                <select
                                    value={newSubscriptionPlanDuration}
                                    onChange={(e) => setNewSubscriptionPlanDuration(e.target.value)}>
                                    <option value='' disabled>Select billing cycle</option>
                                    <option value={"ANNUAL"}>Annual</option>
                                    <option value={"SEMI_ANNUAL"}>Semi Annual</option>
                                    <option value={"QUARTERLY"}>Quarterly</option>
                                    <option value={"MONTHLY"}>Monthly</option>
                                    <option value={"WEEKLY"}>Weekly</option>
                                    <option value={"DAILY"}>Daily</option>
                                    <option value={"PERPETUAL"}>Perpetual</option>
                                </select>
                            </div>
                            <div className="components-container">
                                <p>Deactivation Window<span>*</span></p>
                                <div className="deactivation-window-entry-container">
                                    <input
                                        type="text"
                                        placeholder="Enter duration"
                                        value={newSubscriptionPlanDeactivationWindowDuration}
                                        onChange={(e) =>{
                                            const value = e.target.value.replace(/,/g,'');
                                            if(value === '' || /^\d+$/.test(value)) setNewSubscriptionPlanDeactivationWindowDuration(value);
                                        }}
                                    />
                                    <select 
                                        value={newSubscriptionPlanDeactivationWindowDurationUnits}
                                        onChange={(e) => setNewSubscriptionPlanDeactivationWindowDurationUnits(e.target.value)}>
                                        <option value={''}>Please select</option>
                                        <option value={'HOURS'}>Hour{newSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                        <option value={'DAYS'}>Day{newSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                        <option value={'WEEKS'}>Week{newSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                        <option value={'MONTHS'}>Month{newSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="features-container">
                                <div className="features-title-container">
                                    <h2>Features</h2>
                                    <div>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/add-icon.png`}
                                            title="Add a feature"
                                            onClick={() => {
                                                setNewSubscriptionPlanFeatures([...newSubscriptionPlanFeatures,{id: Date.now(),name: ""}]);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-containers"
                                    style={{display:`${newSubscriptionPlanFeatures.length > 0? 'block':'none'}`}}>
                                    {newSubscriptionPlanFeatures.map((feature,index) =>{
                                        return(
                                            <div key={feature.id} className={`feature-container ${ feature.name.trim() === ''? 'empty':''}`}>
                                                <p>
                                                    {index + 1}.
                                                </p>
                                                <input
                                                    type="text"
                                                    value={feature.name}
                                                    maxLength={32}
                                                    placeholder="Enter feature"
                                                    onChange={(e) =>{
                                                        setNewSubscriptionPlanFeatures(newSubscriptionPlanFeatures.map(f => f.id === feature.id? {...f, name:e.target.value}:f));
                                                    }}
                                                />
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                                    title="Delete feature"
                                                    onClick={() =>{
                                                        setNewSubscriptionPlanFeatures(newSubscriptionPlanFeatures.filter(f => f.id !== feature.id));
                                                    }}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="features-empty-container"
                                    style={{display:`${newSubscriptionPlanFeatures.length > 0? 'none':'flex'}`}}>
                                    <div>
                                        <p>At least one feature is required for a subscription plan.</p>
                                        <p>Click + to add a feature.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="buttons-container">
                                <button className="cancel-add-subscription-button"
                                    onClick={() => setShowAddSubscriptionPlan(false)}>Cancel</button>
                                <button className="add-subscription-button"
                                    onClick={async() =>{
                                        if(newSubscriptionPlanName === ''){
                                            window.alert('Enter the name of the subscription to continue');
                                            return;
                                        }
                                        if(newSubscriptionPlanPrice === ''){
                                            window.alert('Enter the price of the subscription plan to continue');
                                            return;
                                        }
                                        if(newSubscriptionPlanTax === ''){
                                            window.alert('Enter the tax of the subscription plan to continue');
                                            return;
                                        }
                                        if(newSubscriptionPlanDuration === ''){
                                            window.alert('Select the billing cycle of the subscription plan');
                                            return;
                                        }
                                        if(newSubscriptionPlanDeactivationWindowDuration === ''){
                                            window.alert('Enter the deactivation window duration');
                                            return;
                                        }
                                        if(newSubscriptionPlanDeactivationWindowDurationUnits === ''){
                                            window.alert('Select the duration type of the deactivation window');
                                            return;
                                        }
                                        if(newSubscriptionPlanFeatures.length === 0){
                                            window.alert('At lease one feature of the subscription plan is required');
                                            return;
                                        }
                                        newSubscriptionPlanFeatures.forEach(feature =>{
                                            if(!feature || feature.name === ''){
                                                window.alert('Fill in all features fields to proceed');
                                            }
                                        })
                                        await createNewSubscriptionPlan();
                                    }}>Add</button>
                            </div>
                        </div>
                        <div className={`tenant-administrator-add-subscription-plan-visibility-container ${newSubscriptionPlanActiveTab === 'visibility'? 'active':'hidden'}`}>
                            <div className="visibility-selection-container">
                                <input
                                    type="checkbox"
                                    checked={newSubscriptionPlanVisible}
                                    onChange={(e) =>setNewSubscriptionPlanVisible(e.target.checked)}
                                />
                                <p title={newSubscriptionPlanVisible? 'Click to remove this plan from the Subscription Marketplace':'Click to list this plan in the Subscription Marketplace'}
                                    onClick={() =>{
                                        setNewSubscriptionPlanVisible(!newSubscriptionPlanVisible);
                                    }}>This plan is {newSubscriptionPlanVisible? '':'not'} listed in the Subscription Marketplace</p>
                            </div>
                            <div className={`visibility-customers-container ${newSubscriptionPlanVisible? 'active':''}`}>
                                <div className="visibility-customers-container-header">
                                    <h2>Customers who can see the plan</h2>
                                    <button title="Add a customer to the list"
                                        onClick={() => setShowAddSubscriptionPlanCustomersBrowser(true)}>
                                        <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add"/>
                                    </button>
                                </div>
                                <div className="tenant-administrator-new-plan-visibility-customers-table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Server name</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {newSubscriptionPlanCustomers === 'ALL'?
                                            (
                                                <tr>
                                                    <td>Global</td>
                                                    <td>All customers in all servers</td>
                                                </tr>
                                            ):(newSubscriptionPlanCustomers.length > 0 && newSubscriptionPlanCustomers.map((newSubscriptionPlanCustomer,index) =>(
                                                <tr key={index}>
                                                    <td>{newSubscriptionPlanCustomer?.tenantAdminProfile?.profileName}</td>
                                                    <td>{newSubscriptionPlanCustomer?.customer?.external?.name}</td>
                                                    <td>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} title="Delete customer entry"
                                                            onClick={() =>{
                                                                setNewSubscriptionPlanCustomers(
                                                                    newSubscriptionPlanCustomers.filter(customer => customer?.customer?.local?.id !== newSubscriptionPlanCustomer?.customer?.local?.id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            )))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tenant-administrator-add-subscription-plan-customers-browser"
                        style={{display:`${showAddSubscriptionPlanCustomersBrowser && newSubscriptionPlanActiveTab === 'visibility'? 'flex':'none'}`}}>
                        <div className="header">
                            <div className="main-header">
                                <h2>Customers</h2>
                                <p onClick={() => setShowAddSubscriptionPlanCustomersBrowser(false)}>&#10006;</p>
                            </div>
                            <div className="minor-header">
                                <p>Servers</p>
                                <p className="customers-title-paragraph">
                                    Customers{
                                        newSubscriptionPlanAllCustomers? ' - Global':
                                        selectedTenantAdminProfile && selectedTenantAdminProfile.serverName? ` - ${selectedTenantAdminProfile.serverName}`:''}
                                </p>
                            </div>
                        </div>
                        <div className="body">
                            <div className="servers-container">
                                <div className="server-container"
                                    onClick={()=>setNewSubscriptionPlanAllCustomers(true)}>Global
                                </div>
                                {tenantAdminProfiles.length > 0 && tenantAdminProfiles.map(tenantAdminServerModel =>(
                                    <div className="server-container"
                                        key={tenantAdminServerModel?.id}
                                        onClick={() =>{
                                            setNewSubscriptionPlanAllCustomers(false);
                                            setSelectedTenantAdminServerProfileCustomers([]);
                                            setSelectedTenantAdminProfile(tenantAdminServerModel);
                                            setFetchingSelectedTenantAdminServerProfilesCustomers(true);
                                        }}>{tenantAdminServerModel?.profileName}
                                    </div>
                                ))}
                            </div>
                            <div className="server-customers-container">
                                {newSubscriptionPlanAllCustomers?
                                    <div className="all-customers-all-servers">
                                        <p>All customers on all servers</p>
                                    </div>:
                                    <div>
                                        {selectedTenantAdminServerProfileCustomers.length > 0?
                                            <div>{selectedTenantAdminServerProfileCustomers.
                                                slice().filter(customer => !newSubscriptionPlanCustomersLocalIds.includes(customer?.local?.id))
                                                .sort((a,b) => a?.external?.name?.localeCompare(b?.external?.name)).map((customer =>(
                                                <div key={customer?.local?.id} className={`server-customer-container${selectedNewSubscriptionPlanCustomer === customer? ' selected-customer':''}`}
                                                    onClick={() => setSelectedNewSubscriptionPlanCustomer(customer)}>
                                                    {customer?.external?.name}
                                                </div>)))}
                                            </div>:
                                            <div>
                                                {fetchingSelectedTenantAdminServerProfilesCustomers?
                                                    <div className="tenant-administrator-add-subscription-plan-fetching-customers-container">
                                                        <div></div>
                                                        <p>Fetching customers...</p>
                                                    </div>:
                                                    <div>
                                                        {selectedTenantAdminProfile === null || selectedTenantAdminProfile === ''?
                                                            <div className="tenant-administrator-add-subscription-plan-unselected-server-container">
                                                                <p>No server has been selected.</p>
                                                            </div>:
                                                            <div className="tenant-administrator-add-subscription-plan-unavailable-customers-container">
                                                                <p>There are no customers available in this server</p>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="controls">
                            <button onClick={() =>{
                                if(newSubscriptionPlanAllCustomers){
                                    setNewSubscriptionPlanCustomers('ALL');
                                }
                                else{
                                    if(newSubscriptionPlanCustomers === 'ALL') setNewSubscriptionPlanCustomers([{
                                        tenantAdminProfile: selectedTenantAdminProfile,
                                        customer: selectedNewSubscriptionPlanCustomer
                                    }]);
                                    else{
                                        setNewSubscriptionPlanCustomers(prevCustomers => {
                                            if (!prevCustomers.some(entry => 
                                                entry.tenantAdminProfile === selectedTenantAdminProfile && 
                                                entry.customer === selectedNewSubscriptionPlanCustomer)) {
                                                
                                                return [...prevCustomers, {
                                                    tenantAdminProfile: selectedTenantAdminProfile,
                                                    customer: selectedNewSubscriptionPlanCustomer
                                                }];
                                            }
                                            return prevCustomers;
                                        });
                                    }
                                }
                            }}>Add</button>
                            <button onClick={() => setShowAddSubscriptionPlanCustomersBrowser(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tenant-administrator-adding-subscription-plan-container"
                style={{display:showAddingSubscriptionPlan? 'flex':'none'}}>
                <div className="tenant-administrator-adding-subscription-plan-progress-container">
                    <div className="tenant-administrator-adding-subscription-plan-spinner"></div>
                    <p>Adding subscription plan. Please wait...</p>
                </div>
            </div>
            <div className="tenant-administrator-edit-subscription-plan-container"
                style={{display:`${showEditSubscriptionPlan? 'flex':'none'}`}}>
                <div className="tenant-administrator-edit-subscription-plan-main-container">
                    <div className="tenant-administrator-edit-subscription-plan-header-container">
                        <h1>Edit subscription plan</h1>
                        <p onClick={() => setShowEditSubscriptionPlan(false)}>&#10006;</p>
                    </div>
                    <div className="tenant-administrator-edit-subscription-plan-body-container">
                        <div className="tenant-administrator-edit-subscription-plan-navigation-bar">
                            <button className={`${editSubscriptionPlanActiveTab === 'details'? 'active':''}`}
                                onClick={() => setEditSubscriptionPlanActiveTab('details')}>Details</button>
                            <button className={`${editSubscriptionPlanActiveTab === 'visibility'? 'active':''}`}
                                onClick={() => setEditSubscriptionPlanActiveTab('visibility')}>Visibility</button>
                        </div>
                        <div className={`tenant-administrator-edit-subscription-plan-details-container ${editSubscriptionPlanActiveTab === 'details'? 'active':'hidden'}`}>
                            <div className="components-container">
                                <p>Name<span>*</span></p>
                                <input
                                    type="text"
                                    placeholder="Enter the subscription plan name"
                                    value={editSubscriptionPlanName}
                                    onChange={(e) =>{
                                        setEditSubscriptionPlanName(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="components-container" title="Price of the suscription in KES">
                                <p>Price<span>*</span></p>
                                <input
                                    type="text"
                                    placeholder="Enter the price in KES"
                                    value={editSubscriptionPlanPrice}
                                    onChange={(e) =>{
                                        const value = e.target.value.replace(/,/g,'');
                                        if(/^\d*\.?\d{0,2}$/.test(value)) setEditSubscriptionPlanPrice(value)
                                    }}
                                    onFocus={(e) =>{
                                        setEditSubscriptionPlanPrice(editSubscriptionPlanPrice.replace(/[^\d.]/g,''));
                                    }}
                                    onBlur={(e) =>{
                                        if(editSubscriptionPlanPrice !== ''){
                                            setEditSubscriptionPlanPrice('KES ' + Number(editSubscriptionPlanPrice).toLocaleString('en-US',{
                                                minimumFractionDigits:2,
                                                maximumFractionDigits:2
                                            }))
                                        }
                                    }}
                                />
                            </div>
                            <div className="components-container">
                                <p>Tax<span>*</span></p>
                                <input
                                    placeholder="Enter tax in %"
                                    value={editSubscriptionPlanTax}
                                    onChange={(e) =>{
                                        const value = e.target.value.replace(/,/g,'');
                                        if(/^\d*\.?\d{0,2}$/.test(value)) setEditSubscriptionPlanTax(value)
                                    }}
                                    onFocus={(e) =>{
                                        setEditSubscriptionPlanTax(editSubscriptionPlanTax.replace(/[^\d.]/g,''));
                                    }}
                                    onBlur={(e) =>{
                                        if(editSubscriptionPlanTax !== ''){
                                            setEditSubscriptionPlanTax(Number(editSubscriptionPlanTax).toLocaleString('en-US',{
                                                minimumFractionDigits:2,
                                                maximumFractionDigits:2
                                            }) + '%');
                                        }
                                    }}
                                />
                            </div>
                            <div className="components-container">
                                <p>Billing cycle<span>*</span></p>
                                <select
                                    value={editSubscriptionPlanDuration}
                                    onChange={(e) => setEditSubscriptionPlanDuration(e.target.value)}>
                                    <option value='' disabled>Select billing cycle</option>
                                    <option value={"ANNUAL"}>Annual</option>
                                    <option value={"SEMI_ANNUAL"}>Semi Annual</option>
                                    <option value={"QUARTERLY"}>Quarterly</option>
                                    <option value={"MONTHLY"}>Monthly</option>
                                    <option value={"WEEKLY"}>Weekly</option>
                                    <option value={"DAILY"}>Daily</option>
                                    <option value={"PERPETUAL"}>Perpetual</option>
                                </select>
                            </div>
                            <div className="components-container">
                                <p>Deactivation Window<span>*</span></p>
                                <div className="deactivation-window-entry-container">
                                    <input
                                        type="text"
                                        placeholder="Enter duration"
                                        value={editSubscriptionPlanDeactivationWindowDuration}
                                        onChange={(e) =>{
                                            const value = e.target.value.replace(/,/g,'');
                                            if(value === '' || /^\d+$/.test(value)) setEditSubscriptionPlanDeactivationWindowDuration(value);
                                        }}
                                    />
                                    <select 
                                        value={editSubscriptionPlanDeactivationWindowDurationUnits}
                                        onChange={(e) => setEditSubscriptionPlanDeactivationWindowDurationUnits(e.target.value)}>
                                        <option value={''}>Please select</option>
                                        <option value={'HOURS'}>Hour{editSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                        <option value={'DAYS'}>Day{editSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                        <option value={'WEEKS'}>Week{editSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                        <option value={'MONTHS'}>Month{editSubscriptionPlanDeactivationWindowDuration === '1'? '':'s'}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="features-container">
                                <div className="features-title-container">
                                    <h2>Features</h2>
                                    <div>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/add-icon.png`}
                                            title="Add a feature"
                                            onClick={() => {
                                                setEditSubscriptionPlanFeatures([...editSubscriptionPlanFeatures,{id: Date.now(),name: ""}]);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-containers"
                                    style={{display:`${editSubscriptionPlanFeatures.length > 0? 'block':'none'}`}}>
                                    {editSubscriptionPlanFeatures.map((feature,index) =>{
                                        return(
                                            <div key={feature.id} className={`feature-container ${ feature.name.trim() === ''? 'empty':''}`}>
                                                <p>
                                                    {index + 1}.
                                                </p>
                                                <input
                                                    type="text"
                                                    value={feature.name}
                                                    maxLength={32}
                                                    placeholder="Enter feature"
                                                    onChange={(e) =>{
                                                        setEditSubscriptionPlanFeatures(editSubscriptionPlanFeatures.map(f => f.id === feature.id? {...f, name:e.target.value}:f));
                                                    }}
                                                />
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                                    title="Delete feature"
                                                    onClick={() =>{
                                                        setEditSubscriptionPlanFeatures(editSubscriptionPlanFeatures.filter(f => f.id !== feature.id));
                                                    }}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="features-empty-container"
                                    style={{display:`${editSubscriptionPlanFeatures.length > 0? 'none':'flex'}`}}>
                                    <div>
                                        <p>At least one feature is required for a subscription plan.</p>
                                        <p>Click + to add a feature.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="buttons-container">
                                <button className="cancel-edit-subscription-button"
                                    onClick={() => setShowEditSubscriptionPlan(false)}>Cancel</button>
                                <button className="edit-subscription-button"
                                    onClick={async() =>{
                                        if(editSubscriptionPlanName === ''){
                                            window.alert('Enter the name of the subscription to continue');
                                            return;
                                        }
                                        if(editSubscriptionPlanPrice === ''){
                                            window.alert('Enter the price of the subscription plan to continue');
                                            return;
                                        }
                                        if(editSubscriptionPlanTax === ''){
                                            window.alert('Enter the tax of the subscription plan to continue');
                                            return;
                                        }
                                        if(editSubscriptionPlanDuration === ''){
                                            window.alert('Select the billing cycle of the subscription plan');
                                            return;
                                        }
                                        if(editSubscriptionPlanDeactivationWindowDuration === ''){
                                            window.alert('Enter the deactivation window duration');
                                            return;
                                        }
                                        if(editSubscriptionPlanDeactivationWindowDurationUnits === ''){
                                            window.alert('Select the duration type of the deactivation window');
                                            return;
                                        }
                                        if(editSubscriptionPlanFeatures.length === 0){
                                            window.alert('At lease one feature of the subscription plan is required');
                                            return;
                                        }
                                        editSubscriptionPlanFeatures.forEach(feature =>{
                                            if(!feature || feature.name === ''){
                                                window.alert('Fill in all features fields to proceed');
                                            }
                                        })
                                        await updateSubscriptionPlan();
                                    }}>Update</button>
                            </div>
                        </div>
                        <div className={`tenant-administrator-edit-subscription-plan-visibility-container ${editSubscriptionPlanActiveTab === 'visibility'? 'active':'hidden'}`}>
                            <div className="visibility-selection-container">
                                <input
                                    type="checkbox"
                                    checked={editSubscriptionPlanVisible}
                                    onChange={(e) =>setEditSubscriptionPlanVisible(e.target.checked)}
                                />
                                <p title={editSubscriptionPlanVisible? 'Click to remove this plan from the Subscription Marketplace':'Click to list this plan in the Subscription Marketplace'}
                                    onClick={() =>{
                                        setEditSubscriptionPlanVisible(!editSubscriptionPlanVisible);
                                    }}>This plan is {editSubscriptionPlanVisible? '':'not'} listed in the Subscription Marketplace</p>
                            </div>
                            <div className={`visibility-customers-container ${editSubscriptionPlanVisible? 'active':''}`}>
                                <div className="visibility-customers-container-header">
                                    <h2>Customers who can see the plan</h2>
                                    <button title="Add a customer to the list"
                                        onClick={() => setShowEditSubscriptionPlanCustomersBrowser(true)}>
                                        <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add"/>
                                    </button>
                                </div>
                                <div className="tenant-administrator-edit-plan-visibility-customers-table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Server name</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {editSubscriptionPlanCustomers === 'ALL'?
                                            (
                                                <tr>
                                                    <td>Global</td>
                                                    <td>All customers in all servers</td>
                                                </tr>
                                            ):(editSubscriptionPlanCustomers.length > 0 && editSubscriptionPlanCustomers.map((editSubscriptionPlanCustomer) =>(
                                                <tr key={editSubscriptionPlanCustomer?.customer?.local?.id}>
                                                    <td>{editSubscriptionPlanCustomer?.tenantAdminProfile?.profileName}</td>
                                                    <td>{editSubscriptionPlanCustomer?.customer?.external?.name}</td>
                                                    <td>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} title="Delete customer entry"
                                                            onClick={() =>{
                                                                setEditSubscriptionPlanCustomers(
                                                                    editSubscriptionPlanCustomers.filter(customer => customer?.customer?.local?.id !== editSubscriptionPlanCustomer?.customer?.local?.id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            )))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tenant-administrator-edit-subscription-plan-customers-browser"
                        style={{display:`${showEditSubscriptionPlanCustomersBrowser && editSubscriptionPlanActiveTab === 'visibility'? 'flex':'none'}`}}>
                        <div className="header">
                            <div className="main-header">
                                <h2>Customers</h2>
                                <p onClick={() => setShowEditSubscriptionPlanCustomersBrowser(false)}>&#10006;</p>
                            </div>
                            <div className="minor-header">
                                <p>Servers</p>
                                <p className="customers-title-paragraph">
                                    Customers{
                                        editSubscriptionPlanAllCustomers? ' - Global':
                                        selectedTenantAdminProfile && selectedTenantAdminProfile.serverName? ` - ${selectedTenantAdminProfile.serverName}`:''}
                                </p>
                            </div>
                        </div>
                        <div className="body">
                            <div className="servers-container">
                                <div className="server-container"
                                    onClick={()=>setEditSubscriptionPlanAllCustomers(true)}>Global
                                </div>
                                {tenantAdminProfiles.length > 0 && tenantAdminProfiles.map(tenantAdminServerModel =>(
                                    <div className="server-container"
                                        key={tenantAdminServerModel?.id}
                                        onClick={() =>{
                                            setEditSubscriptionPlanAllCustomers(false);
                                            setSelectedTenantAdminServerProfileCustomers([]);
                                            setSelectedTenantAdminProfile(tenantAdminServerModel);
                                            setFetchingSelectedTenantAdminServerProfilesCustomers(true);
                                        }}>{tenantAdminServerModel?.profileName}
                                    </div>
                                ))}
                            </div>
                            <div className="server-customers-container">
                                {editSubscriptionPlanAllCustomers?
                                    <div className="all-customers-all-servers">
                                        <p>All customers on all servers</p>
                                    </div>:
                                    <div>
                                        {selectedTenantAdminServerProfileCustomers.length > 0?
                                            <div>{selectedTenantAdminServerProfileCustomers.
                                                slice().filter(customer => !editSubscriptionPlanCustomersLocalIds.includes(customer?.local?.id))
                                                .sort((a,b) => a?.external?.name?.localeCompare(b?.external?.name)).map((customer =>(
                                                <div key={customer?.local?.id} className={`server-customer-container${selectedEditSubscriptionPlanCustomer === customer? ' selected-customer':''}`}
                                                    onClick={() => setSelectedEditSubscriptionPlanCustomer(customer)}>
                                                    {customer?.external?.name}
                                                </div>)))}
                                            </div>:
                                            <div>
                                                {fetchingSelectedTenantAdminServerProfilesCustomers?
                                                    <div className="tenant-administrator-edit-subscription-plan-fetching-customers-container">
                                                        <div></div>
                                                        <p>Fetching customers...</p>
                                                    </div>:
                                                    <div>
                                                        {selectedTenantAdminProfile === null || selectedTenantAdminProfile === ''?
                                                            <div className="tenant-administrator-edit-subscription-plan-unselected-server-container">
                                                                <p>No server has been selected.</p>
                                                            </div>:
                                                            <div className="tenant-administrator-edit-subscription-plan-unavailable-customers-container">
                                                                <p>There are no customers available in this server</p>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="controls">
                            <button onClick={() =>{
                                if(editSubscriptionPlanAllCustomers){
                                    setEditSubscriptionPlanCustomers('ALL');
                                }
                                else{
                                    if(editSubscriptionPlanCustomers === 'ALL') setEditSubscriptionPlanCustomers([{
                                        tenantAdminProfile: selectedTenantAdminProfile,
                                        customer: selectedEditSubscriptionPlanCustomer
                                    }]);
                                    else{
                                        setEditSubscriptionPlanCustomers(prevCustomers => {
                                            if (!prevCustomers.some(entry => 
                                                entry.tenantAdminProfile === selectedTenantAdminProfile && 
                                                entry.customer === selectedEditSubscriptionPlanCustomer)) {
                                                return [...prevCustomers, {
                                                    tenantAdminProfile: selectedTenantAdminProfile,
                                                    customer: selectedEditSubscriptionPlanCustomer
                                                }];
                                            }
                                            return prevCustomers;
                                        });
                                    }
                                }
                            }}>Add</button>
                            <button onClick={() => setShowEditSubscriptionPlanCustomersBrowser(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tenant-administrator-updating-subscription-plan-container"
                style={{display:`${showUpdatingSubscriptionPlan? 'flex':'none'}`}}>
                <div className="tenant-administrator-updating-subscription-plan-progress-container">
                    <div className="tenant-administrator-updating-subscription-plan-spinner"></div>
                    <p>Updating subscription plan. Please wait...</p>
                </div>
            </div>
            <div className="tenant-administrator-delete-subscription-plan-container"
                style={{display:`${showDeleteSubscriptionPlan? 'flex':'none'}`}}>
                    <div className="tenant-administrator-delete-subscription-plan-main-container">
                        <h1>Delete subscription plan "{deleteSubscriptionPlan && deleteSubscriptionPlan.name? deleteSubscriptionPlan.name:''}"?</h1>
                        <p>Once you delete the subscription plan, it can't be undone.</p>
                        <div className="tenant-administrator-delete-subscription-plan-buttons-container">
                            <button className="cancel-delete-button"
                                onClick={() =>{
                                setDeleteSubscriptionPlan(null);
                                setShowDeleteSubscriptionPlan(false);
                            }}>Don't delete</button>
                            <button className="delete-button"
                                onClick={async() =>{
                                    await DeleteSubscriptionPlan();
                                }}>Delete plan</button>
                        </div>
                        <div className="tenant-administrator-delete-subscription-escape-button-container"
                            onClick={() =>{
                                setDeleteSubscriptionPlan(null);
                                setShowDeleteSubscriptionPlan(false);
                            }}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
            </div>
            <div className="tenant-administrator-deleting-subscription-plan-container"
                style={{display:showDeletingSubscriptionPlan? 'flex':'none'}}>
                <div className="tenant-administrator-deleting-subscription-plan-progress-container">
                    <div className="tenant-administrator-deleting-subscription-plan-spinner"></div>
                    <p>Deleting subscription plan. Please wait...</p>
                </div>
            </div>
        </div>
    );
};
export default SubscriptionPlans;